import { MarketplaceBreadcrumb } from '@/components/marketplace/marketplaceBreadcrumb';
import { MarketPlaceLongBody } from '@/components/marketplace/marketplaceLongBody';
import { SubCategoryPage } from '@/components/marketplace/subCategoryPage';
import { MetaHead } from '@/components/shared/metaHead';
import { SchemaHead } from '@/components/shared/schemaHead';
import ToastProvider from '@/components/shared/toast/ToastContainer';
import { IMarketingBanner, IMetaDetails, IMetaHead, IPageMenu, ISubCategoryData } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import blogService from '@/lib/services/blogService';
import marketPlaceService from '@/lib/services/marketPlaceService';
import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react'
type props = {
    subCategoryPageData: ISubCategoryData
    metaDetails: IMetaDetails
    navSchemaData: IPageMenu[]
    marketPlaceNavSchema: IPageMenu[]
    marketingBanner: IMarketingBanner[]

}
const MktSubCategoryPage = ({ subCategoryPageData, navSchemaData, marketPlaceNavSchema, marketingBanner }: props) => {
    const baseUrl = process.env.SITE_URL;
    const metaDetails = subCategoryPageData?.metaDetails || {}
    let breadCrumJson = [
        {
            name: `${subCategoryPageData.serviceName}`,
            url: `${baseUrl}/online-store/${subCategoryPageData.serviceSlug}`
        },
        {
            name: `${subCategoryPageData.categoryName}`,
            url: ''
        }
    ];
    const pageNo = subCategoryPageData?.pagination?.pageNo || 0;
    const pageNoPrefix = (pageNo > 1 ? `Page ${pageNo} - ` : '')
    const metaData: IMetaHead = {
        title: (() => {
            if (metaDetails && subCategoryPageData) {
                if (subCategoryPageData.maxDiscount == '0') {
                    return pageNoPrefix + (metaDetails.meta_title?.split('-')[0] || "");
                } else {
                    return pageNoPrefix + (metaDetails.meta_title?.replaceAll(/{(.*?)}/g, subCategoryPageData.maxDiscount) || "");
                }
            }
            return "";
        })(),
        description: metaDetails ? (pageNoPrefix + (metaDetails.meta_description || "")) : "",
        ogImage:`${subCategoryPageData.products[0].files[0].filePath}`
    };
    const schemaData = () => {
        const itemListElement: string[] = [];
        subCategoryPageData?.products?.forEach((d, idx) => {
            itemListElement.push(`{
                        "@type": "ListItem",
                        "position": ${idx + 1},
                        "name": "${d.productName}",
                        "url": "${`${baseUrl}/online-store/${d.productSlug}`}"
                    }`);
        })
        return itemListElement;
    };
    const faqData = () => {
        const faqs = []
        if (metaDetails && metaDetails.FAQ && metaDetails.FAQ.FAQ)
            for (const d of metaDetails.FAQ.FAQ) {
                faqs.push(`{
              "@type":"Question",
              "name":"${d.question}",
              "acceptedAnswer":{
              "@type":"Answer",
              "text":"${d.answer.replace(new RegExp('<[^>]*>', 'g'), ' ').replace(/(\s\s\s*)/g, ' ').replace("&#8217;", "'")}"}
            }`)
            }
        return faqs
    }
    const _schema = [
        {
            __html: `
            {
                "@context": "https://schema.org/",
                "@type": "ItemList",
                "itemListElement": [${schemaData()}]
            }`
        },
        {
            __html: `
             {
           "@context": "http://schema.org/",
           "@type":"FAQPage",
           "mainEntity" : [${faqData()}]
             }`
        }];

    const { funs: { toggleFloatingWidget } } = useGlobalContext();
    useEffect(() => {
        toggleFloatingWidget(true);
    }, []);
    return (<>
        <ToastProvider >
            <MetaHead metaData={metaData} />
            <MarketplaceBreadcrumb breadCrumbJson={breadCrumJson} customCss={{ "marginTop": '92px' }} />
            <SchemaHead data={_schema} navSchemaData={[...navSchemaData, ...marketPlaceNavSchema]} />
            <SubCategoryPage data={subCategoryPageData} marketingBanner={marketingBanner} />
            <MarketPlaceLongBody metaDetails={metaDetails} />
        </ToastProvider>
    </>
    )
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const subCategorySlug: any = context?.params?.subcategory || '';
    const categorySlug: any = context?.params?.category || '';
    if (context.query.page && (isNaN(Number(context.query.page)) || Number(context.query.page) < 1)) {
        return {
            notFound: true,
        };
    }
    const pageNo = context.query.page || 1;
    const body = {
        "CityName": "Delhi",
        "SearchSlug": `${subCategorySlug}`,
        "PageSize": 16,
        "PageNo": pageNo
    }
    const data = await marketPlaceService.getSubCategoryData(body);
    data.filters = data?.filters?.map((f: any) => {
        if (f.isGenerateFilterUrl == 1) {
            return {
                ...f, attributeValues: f.attributeValues.map((a: any) => {
                    return {
                        ...a,
                        url: `${process.env.SITE_URL}/online-store/${a.attributeValueSlug}-online-${subCategorySlug}-${data.categoryIdentifier}-${f.attributeId}`
                    }
                })
            }
        } else {
            return f
        }
    })
    if (data && Object.keys(data).length > 0) {
        if (data.serviceSlug !== categorySlug) {
            return {
                notFound: true
            }
        } else {
            const metaDetails = await blogService.getMarketPlaceSeoContent(subCategorySlug);
            data.metaDetails = metaDetails
        }
    }
    const marketingBanner = await blogService.getMarketingBanners('sub');
    if (!Object.keys(data).length)
        return { notFound: true }
    return {
        props: { subCategoryPageData: data, marketingBanner }
    }


}
export default MktSubCategoryPage;